import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// Get Leave Report
export const get_leave_reports= async (filterPayload) => {
    let response = await axios.post(`${secureLocalStorage.getItem("baseURL")}/api/get-employee-leave-Reports/`,filterPayload);
    return response.data;
}